import { classNamesOrEmpty } from "../../style/common";
import { CardBack } from "./CardBack";

export type CardVariantImageCardBackOverlayProps = {
    className?: string | undefined
}

export function CardVariantImageCardBackOverlay(props: CardVariantImageCardBackOverlayProps) {
    return (
        <div className={`rounded-2xl overflow-hidden p-[1.5px] absolute top-0 bottom-0 left-0 right-0 ${classNamesOrEmpty(props.className)}`}>
            <CardBack />
        </div>
    )
}